import * as React from 'react';

type Props = {
  children?: React.ReactNode,
  isVisible: boolean
};

const InspirationalMaterialsModalTab = (
  {
    children,
    isVisible
  }: Props
): JSX.Element => (
  <div style={{ display: isVisible ? 'block' : 'none' }}>
    {children}
  </div>
);

export default InspirationalMaterialsModalTab;
